export default __webpack_public_path__ + "static/media/7.0af240a9.png";